import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles/other.css';
import { Link, Navigate } from "react-router-dom";
import Axios from 'axios';
import Moment from 'react-moment';

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';
import { getInitials, showSortIcon } from '../utilities/OtherUtilities.js';

// import components
import ProfileImageSmall from '../components/ProfileImageSmall.js';

class FundingsTile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            redirectTo: null,
            selectedItems: [],
            showPopupTableActions: false,
        }

        this.refPopupTableActions = React.createRef();
    }

    componentDidMount(){
        this.setState({ redirectTo: null });
        window.addEventListener('click', this.onGlobalClick);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.onGlobalClick);
    }

    /* This method is triggered on every click on screen and is checking if some popup is opened nad user clicked out of this popup so it would close that popup in that situation */
    onGlobalClick = (e) => {
        if ( (!this.refPopupTableActions.current.contains(e.target)) && this.state.showPopupTableActions) {
            // user clicked out of the PopupTableActions and that popup is now opened
            this.setState({ showPopupTableActions: false })
        }
    }

    openFundingProfilePage = (event, id, openTile) => {
        var openTileText = "";
        if(openTile != ""){
            openTileText = "?tile="+openTile;
        }
        if(event.ctrlKey || event.metaKey){ window.open("/Funding/"+id+""+openTileText, '_blank', 'noreferrer'); }
        else { this.setState({ redirectTo: "/Funding/"+id+""+openTileText }); }
    }

    render() {
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} />
        }

        return (
            <div style={{height: "calc(100% - 0px)", width: "100%"}}>
                <div className="universalTableTile">
                    <div style={{width: this.props.leftMenuOpened == "true" ? "calc(100% - 0px - 80px)" : "calc(100% - 0px - 80px)", height: "calc(100% - 0px - 60px)", position: "absolute", overflowX: "auto", overflowY: "auto"}}> {/* 240px including the padding */}
                        <table className="universalTable">
                            <tr>
                                <td className="universalTableHeader universalTableFirstFixedColumnHeader" onClick={() => this.props.changeSorting("tasks_tp")}>Approved Application {showSortIcon("tasks_tp",this.props.sortBy,this.props.sortTp)}</td>
                                <td className="universalTableHeader universalTableHeaderRole" onClick={() => this.props.changeSorting("ins_at")}>Grant {showSortIcon("ins_at",this.props.sortBy,this.props.sortTp)}</td>
                                <td className="universalTableHeader universalTableHeaderOther" onClick={() => this.props.changeSorting("role")}>Approved Amount {showSortIcon("role",this.props.sortBy,this.props.sortTp)}</td>
                                <td className="universalTableHeader universalTableHeaderOther" onClick={() => this.props.changeSorting("role")}>Created by {showSortIcon("role",this.props.sortBy,this.props.sortTp)}</td>
                            </tr>

                            {this.props.fundingsData.map(function (item, index) {
                                return (
                                    <tr key={index}>

                                        <td className="universalTableFirstFixedColumn" onClick={(event) => this.openFundingProfilePage(event, item.id, "")}>
                                            <div className="responsiveThreeDotsContainer flex">
                                                <span className="fontPoppinsRegular13 responsiveThreeDots">{item.project_name}</span>
                                            </div>
                                        </td>

                                        <td className="universalTableGeneralDiv" nowrap="nowrap" onClick={(event) => this.openFundingProfilePage(event, item.id, "")}>{item.grant}</td>
                                        <td className="universalTableGeneralDiv" nowrap="nowrap" onClick={(event) => this.openFundingProfilePage(event, item.id, "")}>{item.amount}</td>
                                        <td className="universalTableGeneralDiv" nowrap="nowrap" onClick={(event) => this.openFundingProfilePage(event, item.id, "")}>{item.created_by}</td>
                                    </tr>
                                )
                            }.bind(this))}

                            {/* if array empty then show row with text "Loading..." */}
                            {this.props.fundingsData.length == 0 && !this.props.noRecordsFound ? <tr> <td className="universalTableGeneralDiv" nowrap="nowrap" colspan="4" style={{textAlign: "center"}}>{"Loading..."}</td> </tr> : null}

                            {/* if array empty then show row with text "No Records Found" */}
                            {this.props.fundingsData.length == 0 && this.props.noRecordsFound ? <tr> <td className="universalTableGeneralDiv" nowrap="nowrap" colspan="4" style={{textAlign: "center"}}>{"No Records"}</td> </tr> : null}

                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default FundingsTile;
